export default "__VITE_ASSET__CtWywBVM__"